import React from 'react';
import { HTMLtoJSX } from '../../../../../../helpers';
import { HeadingSizeTags, TitleSizeType } from '../../../../../../types';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import styles from './ProductModuleHeading.module.scss';

export interface ProductModuleHeadingProps {
  heading: React.ReactNode;
  titleSize?: TitleSizeType;
  text?: React.ReactNode;
}

export function ProductModuleHeading(props: ProductModuleHeadingProps) {
  const { heading, titleSize, text } = props;
  const { location } = useRootSelector(selectPageConfig);

  const HeadingTag = titleSize ? HeadingSizeTags[titleSize] : 'div';

  return (
    <div className={styles.wrapper}>
      <HeadingTag className={styles.heading}>{heading}</HeadingTag>
      {text && <div className={styles.text}>{HTMLtoJSX(text, location)}</div>}
    </div>
  );
}
